// @ts-nocheck

export const TABBAR_BASE_HEIGHT = 3.6; // em
export const TABBAR_ITEM_TRANSITION = 200; // ms
